<tt-page>
    <tt-page-heading ttModel="p2_m_facts" ttTranslate></tt-page-heading>
    <tt-grid [ttOptions]="grid"></tt-grid>
</tt-page>
